import areas from './areas'
import inputs from './inputs'
import sections from './sections'
import taxInformation from './taxInformation'
import reports from './reports'
import router from '@/router'

export default {
  namespaced: true,

  modules: {
    areas,
    inputs,
    sections,
    taxInformation,
    reports
  },

  state: () => ({
    data: {
      name: '',
      _id: '',
      uuid: '',
      wansoftId: '',
      fees: {},
      country: '',
      allowedProviders: [],
      deliveryAddresses: [],
      useWhiteList: null,
      isLive: null,
      balanceLimit: null
    }
  }),

  actions: {
    select: async function (ctx, restaurant) {
      await ctx.dispatch('reset')
      await ctx.commit('set', restaurant)
      await ctx.commit('login/setRole', restaurant.role, { root: true })
      await ctx.commit('login/setEmployment', restaurant.employment, { root: true })
      await ctx.commit('login/setPermissions', restaurant.permissions, { root: true })

      const areasParams = {
        select: '_id name'
      }
      await ctx.dispatch('areas/get', areasParams)

      const sectionsParams = {
        select: '_id name area'
      }
      ctx.dispatch('sections/get', sectionsParams)
      ctx.dispatch('taxInformation/get')
      ctx.dispatch('subscribeRestaurantChannel')
    },

    reset: function (ctx) {
      ctx.commit('reset')
      ctx.commit('areas/reset')
      ctx.commit('inputs/reset')
      ctx.commit('sections/reset')
      ctx.commit('taxInformation/reset')
      ctx.commit('reports/reset')
    },

    subscribeRestaurantChannel: async function (ctx) {
      const channel = await this._vm.$pusher.subscribe(`restaurant-${ctx.state.data._id}-channel`)
      const userRestaurantChannel = await this._vm.$pusher.subscribe(`${ctx.state.data._id}-${ctx.rootState.login.user._id}-channel`)
      const permissionsChannel = await this._vm.$pusher.subscribe(`permissions-${ctx.state.data._id}-${ctx.rootState.login.user._id}-channel`)

      userRestaurantChannel.bind('prospect-notification', function (data) {
        router.push({ name: 'IntelligentPurchase' })
      })

      channel.bind('area-created', function (data) {
        ctx.commit('areas/add', data)
      })
      channel.bind('area-updated', function (data) {
        ctx.commit('areas/update', data)
      })
      channel.bind('area-deleted', function (data) {
        ctx.commit('areas/delete', data)
      })

      channel.bind('section-created', function (data) {
        ctx.commit('sections/add', data)
      })
      channel.bind('section-updated', function (data) {
        ctx.commit('sections/update', data)
      })
      channel.bind('section-deleted', function (data) {
        ctx.commit('sections/delete', data)
      })

      permissionsChannel.bind('permissions-update', function (data) {
        ctx.commit('login/setPermissions', data, { root: true })
      })
    },

    unsubscribeRestaurantChannel: async function (ctx) {
      this._vm.$pusher.unsubscribe(`restaurant-${ctx.state.data._id}-channel`)
      this._vm.$pusher.unsubscribe(`${ctx.state.data._id}-${ctx.rootState.login.user._id}-channel`)
      this._vm.$pusher.unsubscribe(`permissions-${ctx.state.data._id}-${ctx.rootState.login.user._id}-channel`)
    }
  },

  mutations: {
    set: function (state, restaurant) {
      const {
        name,
        _id,
        id,
        fees,
        wansoftId,
        country,
        allowedProviders,
        deliveryAddresses,
        useWhiteList,
        isLive,
        balanceLimit
      } = restaurant
      state.data = {
        name,
        _id,
        id,
        fees,
        wansoftId,
        country,
        allowedProviders,
        deliveryAddresses,
        useWhiteList,
        isLive,
        balanceLimit
      }
    },
    reset: function (state) {
      state.data = {
        name: '',
        _id: '',
        uuid: '',
        wansoftId: '',
        fees: {},
        allowedProviders: [],
        deliveryAddresses: [],
        useWhiteList: null,
        isLive: null,
        balanceLimit: null
      }
    }
  },

  getters: {
    country: function (state, getters, rootState) {
      const country = rootState.userProvider ? 'MX' : (state.data.country || '')
      return country.toUpperCase()
    },
    isLive: function (state) {
      return state.data.isLive
    }
  }
}
